/* global Swiper:true */
/**
 * https://swiperjs.com
 * Note: if imported through ES6 import statement, use the .mjs version, and set Codekit compile option for this file to "import ES6".
 * Codekit will throw errors until all modules and shared are downloaded in the respective directories. The pb is that the bundle is not a bundle, and requests loading all the dependencies.
 * Importing from CDN throws codekit errors (external dependency), so not ideal either.
 * Easier to load from the html scripts, BUT need to defer the loading of this & the Swiper scripts, otherwise this one finishes loading before Swiper...
*/

const swiper = new Swiper('.mySwiper', {
    // Optional parameters
    //direction: 'vertical',
    loop: true,
    //longSwipes: false,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    spaceBetween: 30,
    centeredSlides: true,
    //grabCursor: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        //type: 'bullets',
        clickable: true
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }

    // And if we need scrollbar
    /*   scrollbar: {
        el: '.swiper-scrollbar'
    } */
});
